/**
 * Same-app links keep a real `href` so they stay crawlable, shareable and
 * middle-clickable, but a plain click is handed to the router instead of the
 * browser. A document load would repaint the page being left (scrolling it
 * back to the top) before the destination ever appears.
 */
import { navigate } from 'gatsby';
import type React from 'react';

/** A click the browser would turn into a same-tab document load. */
export const isPlainClick = (event: React.MouseEvent): boolean =>
  !event.defaultPrevented &&
  event.button === 0 &&
  !event.metaKey &&
  !event.ctrlKey &&
  !event.shiftKey &&
  !event.altKey;

/** Routes a plain click through `go`; leaves modified clicks to the browser. */
export function routeOnClick(event: React.MouseEvent, go: () => void): void {
  if (!isPlainClick(event)) return;
  event.preventDefault();
  go();
}

/** Routes a plain click to `to` when the link has nothing else to record. */
export function routeTo(event: React.MouseEvent, to: string): void {
  routeOnClick(event, () => void navigate(to));
}
